import React from 'react';
import {
  Page,
  Grid,
  CopyColumn,
  Title,
  Body,
  HeroColumn,
  HeroImage,
} from './styles';
import { Button } from '@uala/abra';

const WAITLIST_URL = 'https://form.typeform.com/to/XLZdt51m';

const SuspendedLanding: React.FC = () => {
  return (
    <Page>
      <Grid>
        <CopyColumn>
          <Title>Muy pronto tu empresa va a poder operar con Ualá Bis</Title>
          <Body>
            Estamos trabajando para ofrecerte la mejor solución para tu gestión diaria. <b>Completá tus datos para formar parte de la lista de espera</b> y enterarte de las novedades.
          </Body>
          <Button
            href={WAITLIST_URL}
            target="_blank"
            rel="noopener noreferrer"
            as="a"
          >
            Unirse a la lista de espera
          </Button>
        </CopyColumn>
        <HeroColumn>
          <HeroImage
            src={`/images/bis.png`}
            alt="Ualá Bis"
          />
        </HeroColumn>
      </Grid>
    </Page>
  );
};

export default SuspendedLanding;
